var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.4","transform":"translate(2 2)"},[React.createElement("rect",{"width":"13","height":"13","y":"1","rx":"2","key":0}),React.createElement("path",{"d":"M9 0v2M4 0v2M0 5h13","key":1})]));
}

Calendar.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18"};

module.exports = Calendar;

Calendar.default = Calendar;
